/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/prefer-default-export */

import ShopTabbedMain from "../components/pages/user/shop/ShopTabbedMain";

export const SellerShopSiteRoutes = [
    // Main
  { path: "/", component: ShopTabbedMain, exact: true },
  { path: "/products", component: ShopTabbedMain, exact: true },
  { path: "/cart", component: ShopTabbedMain, exact: true },
  { path: "/account", component: ShopTabbedMain, exact: true },

  { path: "/products/sort/:sort", component: ShopTabbedMain, exact: true },
  { path: "/products/search", component: ShopTabbedMain, exact: true },
  { path: "/products/search/:query", component: ShopTabbedMain, exact: true },
  { path: "/products/:prodId", component: ShopTabbedMain, exact: true },

	// Checkout - common component with marketplace shop
  { path: "/cart/checkout", component: ShopTabbedMain },
  { path: "/cart/payment-page", component: ShopTabbedMain },
  { path: "/cart/order-success", component: ShopTabbedMain },

  // Orders - common component with marketplace shop
  { path: "/account/orders", component: ShopTabbedMain, exact: true },
  { path: "/account/orders/:orderId", component: ShopTabbedMain, exact: true },
  { path: "/account/wishlist", component: ShopTabbedMain, exact: true },
  { path: "/account/appointments", component: ShopTabbedMain, exact: true },
  { path: "/account/addresses", component: ShopTabbedMain, exact: true },
  { path: "/account/mytryons", component: ShopTabbedMain, exact: true },
  { path: "/account/tryonprofile", component: ShopTabbedMain, exact: true },

];
